import { clearChatPassphrase } from './chatCrypto';

export const UI_PREFS_KEYS = {
  sidebarWidth: 'sidebarWidth',
  chatsSectionHeight: 'chatsSectionHeight',
  theme: 'theme',
  locale: 'locale',
};

export const SESSION_KEYS = {
  openIncomingRequests: 'openIncomingRequests',
};

const LEGACY_SENSITIVE_LOCAL_KEYS = [
  'isAuthenticated',
  'selectedChatId',
  'workspace_chats',
  'workspace_chat_previews',
  'lynx.chatPassphrase',
];

const LEGACY_SENSITIVE_SESSION_KEYS = [
  'isAuthenticated',
  'selectedChatId',
  'workspace_chats',
  'workspace_chat_previews',
];

/** Remove sensitive data left from older app versions. */
export function purgeLegacySensitiveStorage() {
  LEGACY_SENSITIVE_LOCAL_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
  });
  LEGACY_SENSITIVE_SESSION_KEYS.forEach((key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // ignore
    }
  });
}

export function getSessionItem(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setSessionItem(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // ignore quota / private mode errors
  }
}

export function removeSessionItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function getUiPref(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setUiPref(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

export function clearClientStorage() {
  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }
  try {
    localStorage.clear();
  } catch {
    // ignore
  }
  clearChatPassphrase();
}
